/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import AIPromptModal from '@/component/common/modal/AIPrompt/AIPromptModal';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { TextField, Dialog } from '@material-ui/core';
import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { updateTabNameAfterSendMessage, onUpdateTabChatConfigurations, handleToggleUsingBasicPrompt, openPromptTicketPanel } from '../handler/ChatAIHandler';
import { sendAIChatMessage } from '@/service/chatAIService';
import { userAtom } from '@/state/atom/userAtom';
import { buildDrillDownSearchParam } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import {
    formatUserDateTime,
    resolveUserTimezone,
    getLocalTodayString,
    getLocalMondayString,
    getLocalAgoDateString
} from '@/common/utils/timezoneUtils';
import { createKibanaInteractChatAI } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { v4 as uuidv4 } from 'uuid';

import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { setPanelSelector } from '@/state/selector/panelSelector';

import { getDrilldownItemDataSelected } from "@/component/ticketList/handler/KnowledgeTicketHandler"
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useDropzone } from 'react-dropzone';
import { useSnackbar } from 'notistack';
import ImageCapture from './InputChatAiGroupButtons/components/ImageCapture';
import { updatePublicAPI } from '@/service/publicService';
import InputChatAiGroupButtons from './InputChatAiGroupButtons';
import PromptButton from './InputChatAiGroupButtons/components/PromptButton';
import {
    removeUploadedImage,
    cleanupUploadedImages,
    checkImageCaptureSupport,
} from './InputChatAiGroupButtons/handler/UploadImageHandler';
import UploadFile from './InputChatAiGroupButtons/components/UploadFile';
import AiPreviewUploadFiles from './InputChatAiGroupButtons/components/AiPreviewUploadFiles';
import {
    removeUploadedFile,
    cleanupUploadedFiles
} from './InputChatAiGroupButtons/handler/UploadFileHandler';
import { acceptAttachments, handlePasteAttachments } from './InputChatAiGroupButtons/handler/AiChatAttachmentHandler';
import { isDisplayFileTranslationSetting, getStatusUsingFileTranslationProject } from '@/component/project/handler/ProjectProfileManagementHandler';
import SelectedMcpServerChips from './SelectedMcpServerChips';
import { isShowKibanaAnalysisOption } from './InputChatAiGroupButtons/handler/MCPServerDropdownHandler';
import SendIcon from '@/component/common/icons/SendIcon';
import StreamStopIcon from '@/component/common/icons/StreamStopIcon';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function InputChatAI(props) {
    // Subscribe to translation updates so displayed placeholder re-renders on language change
    useTranslationSubscription();
    
    let {
        setListMessageContent,
        panelId,
        tabId,
        API,
        projectInfo,
        setTriggerReload,
        filterKnowledgeListData,
        basicPrompt,
        isEnableBtnSend,
        setIsEnableBtnSend,
        listMessageContent,
        isAiAssistantLog,
        resetSearchCondition,
        corporationSelected,
        tabNameChatAI,
        titleTicket,
        setUserSelectedPrompt,
        userSelectedPrompt,
        promptInternalTicket,
        promptExternalTicket,
        setIsOpenModalReloadPage,
        isLoading,
        setIsLoading,
        usingBasicPrompt,
        setIdOfResponseMessage,
        isUsingKnowledgeService,
        toggleUsingKnowledgeTicketList,
        setToggleUsingKnowledgeTicketList,
        usingChatGptModel,
        setUsingChatGptModel,
        selectedMcpServers,
        usingReasoningEffort,
        setUsingReasoningEffort,
        isShowButtonStop,
        setIsShowButtonStop,
        setIsOnlyRunChatAI,
        streamedContent, 
        setIsStopStreamContent,
        idOfResponseMessage,
        reasoningDataStream,
        setReasoningDataStream,
        mcpServerOptions,
        setSelectedMcpServers,
        selectedCorporationDetail,
        reOpenKnowledgePanel,
        isInvalidPrecondition,
        initHitNumber,
        chatGPTModelListOptions
    } = props;

    const [promptOpen, setPromptOpen] = useState(false);
    const [textInput, setTextInput] = useState('');
    const [toggleUsingBasicPrompt, setToggleUsingBasicPrompt] = useState(usingBasicPrompt)

    const corporationDetail = useRecoilValue(corporationAtom);
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isDisabledInputChat, setIsDisabledInputChat] = useState(false);
    const [actionError, setActionError] = useState('');

    // ref
    const inputRef = useRef();
    const uploadFileRef = useRef();
    const imageCaptureRef = useRef();

    const [uploadImgs, setUploadImgs] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const [openPreviewImage, setOpenPreviewImage] = useState({isOpen: false, imgUrl: ''});
    const [isDisplayImageCapture, setIsDisplayImageCapture] = useState(false);

    const chatThreadId = filterKnowledgeListData?.threadId;
    const { enqueueSnackbar } = useSnackbar();

    const canUploadImgToSendAi = useMemo(() => {
        return OpenAiUtil.isSupportMultiModal(usingChatGptModel, usingReasoningEffort)
    }, [usingChatGptModel, usingReasoningEffort]);

    const hasUploadingItem = useMemo(() => {
        const isUploadingItem = item => item.uploadStatus === Constant.AI_CHAT_UPLOAD_STATUS.UPLOADING;
        return uploadImgs.some(isUploadingItem) || uploadFiles.some(isUploadingItem);
    }, [uploadImgs, uploadFiles]);

    // Only successfully uploaded items are sent; ERROR items stay in the preview until removed
    const successUploadImgs = useMemo(() => {
        return uploadImgs.filter(img => img.uploadStatus === Constant.AI_CHAT_UPLOAD_STATUS.SUCCESS);
    }, [uploadImgs]);

    const successUploadFiles = useMemo(() => {
        return uploadFiles.filter(file => file.uploadStatus === Constant.AI_CHAT_UPLOAD_STATUS.SUCCESS);
    }, [uploadFiles]);

    const isFileTranslationEnabled = useMemo(() => {
        // If chat owner project = project inuse (or ALL_KNOWLEDGE_IN_ORG) → use existing atom data
        if (
            Utils.isEmptyObject(projectInfo)
            || projectInfo.id === projectInuseDetail?.id
        ) {
            return isDisplayFileTranslationSetting(corporationDetail)
                && getStatusUsingFileTranslationProject(projectInuseDetail);
        }
        // Chat owner project belongs to another org → use fetched data
        return isDisplayFileTranslationSetting(selectedCorporationDetail)
            && getStatusUsingFileTranslationProject(projectInfo);
    }, [projectInfo, projectInuseDetail, corporationDetail, selectedCorporationDetail]);

    // Same condition as the [+] menu "ファイル" item: drag & drop / paste are blocked when it is hidden
    const isCanAttachFile = canUploadImgToSendAi || isFileTranslationEnabled;

    // clean up upload imgs and files
    useEffect(() => {
        return () => {
            cleanupUploadedImages(uploadImgs, setUploadImgs);
            cleanupUploadedFiles(uploadFiles, setUploadFiles);
        }
    }, [chatThreadId]);

    // check is can ImageCapture on mobile
    useEffect(() => {
        if (!canUploadImgToSendAi) return;
        setIsDisplayImageCapture(checkImageCaptureSupport());
    }, []);

    const onChangeChatInput = e => {
        setTextInput(e.target.value);
    };

    const getAttachmentContext = () => ({
        uploadImgs,
        uploadFiles,
        setUploadImgs,
        setUploadFiles,
        enqueueSnackbar,
        corporationDetail,
        projectInuseDetail,
        chatThreadId,
        inputRef
    });

    const onPasteChatInput = (e) => {
        if (!isCanAttachFile) return;
        handlePasteAttachments(e, getAttachmentContext());
    };

    const onEnterTextInput = async e => {
        if (!isCanSendChat()) return;
        
        if(e.key === 'Enter'&& !e.shiftKey ){
            e.preventDefault();
        }
        if (e.key === 'Enter' && !e.shiftKey) {
            const value = e.target.value;
            try {
                onSendMessage(value);
            } catch (error) {
                console.error('onEnterTextInput err: ', error);
                setUserSelectedPrompt([]);
                setIsEnableBtnSend(true);
            }
        }
    };

    const getOptionsSearch = () => {
        let keywordSearch = '';
        // Replace JP space
        if (filterKnowledgeListData.viewStructure?.keyword) {
            keywordSearch = filterKnowledgeListData.viewStructure?.keyword
                ?.toString()
                .replace(/\s+/g, ' ');
        }

        let keywordList = [];
        let methodSearch = Constant.SETTING_SEARCH_KEYWORD.AND;
        if(filterKnowledgeListData.viewStructure?.options?.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR){
            keywordList = [];
        }else{
             keywordList = keywordSearch ? keywordSearch.split(' ') : [];
             methodSearch = filterKnowledgeListData.viewStructure?.options?.method
                ? filterKnowledgeListData.viewStructure?.options?.method
                : Constant.SETTING_SEARCH_KEYWORD.AND
        }

        let optionSearch = {
            methodSearch: methodSearch,
            attributeSearch: filterKnowledgeListData.viewStructure?.options?.attribute
                ? filterKnowledgeListData.viewStructure?.options?.attribute
                : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
            formatSearch: '',
            keywordList: keywordList
        };

        // Search by date / time
        let fromSearchDate;
        let toSearchDate;

        let agoUnit = '';
        if (
            filterKnowledgeListData.viewStructure.options?.searchDateType ===
            Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
        ) {
            agoUnit = filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
            let agoValue = filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                : 0;
            let agoUnitTime =
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                    ? 7 * 24 * 60 * 60 * 1000
                    : 24 * 60 * 60 * 1000;

            // TZL-001: compute dates in the user's timezone (same source the BE uses to build the UTC range)
            const tz = resolveUserTimezone(userDetail?.userSetting);

            // toSearchDate is today
            toSearchDate = getLocalTodayString(tz);

            // 0 days ago
            if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
                fromSearchDate = toSearchDate;
            } else if (
                !agoValue &&
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
            ) {
                // 0 week ago = monday - today
                fromSearchDate = getLocalMondayString(tz);
            } else {
                fromSearchDate = getLocalAgoDateString(agoValue, agoUnitTime, tz);
            }

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;
        } else {
            if (filterKnowledgeListData.viewStructure.options?.from) {
                fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
                optionSearch.fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
            }

            if (filterKnowledgeListData.viewStructure.options?.to) {
                toSearchDate = filterKnowledgeListData.viewStructure.options.to;
                optionSearch.toSearchDate = filterKnowledgeListData.viewStructure.options.to;
            }

            if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
                // switch search date
                let newFromSearchDate = toSearchDate;
                let newToSearchDate = fromSearchDate;

                fromSearchDate = newFromSearchDate;
                toSearchDate = newToSearchDate;

                optionSearch.fromSearchDate = fromSearchDate;
                optionSearch.toSearchDate = toSearchDate;
            }
        }

        if (filterKnowledgeListData?.viewStructure?.options?.otherFields) {
            optionSearch.formatSearch = JSON.stringify(
                filterKnowledgeListData.viewStructure.options.otherFields
            );
        }

        // Sort
        optionSearch.sortType = filterKnowledgeListData?.viewStructure?.options?.hasOwnProperty('sort') && filterKnowledgeListData?.viewStructure?.options['sort']
            ? filterKnowledgeListData.viewStructure?.options['sort']
            : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

        if(filterKnowledgeListData.viewStructure?.options?.getListPdfPage){
            optionSearch.getListPdfPage = filterKnowledgeListData.viewStructure?.options?.getListPdfPage
        }

        if(!Utils.isEmptyString(filterKnowledgeListData.viewStructure?.options?.filePdfId)){
            optionSearch.filePdfId = filterKnowledgeListData.viewStructure?.options?.filePdfId
        }

        optionSearch.isIncludeAttachPdf = 1
        optionSearch.isIncludePdfPage = 1
        optionSearch.isSearchSynonym = 0
        return optionSearch;
    };

    const onSendMessage = async value => {
        if (!isCanSendChat()) return;
        setReasoningDataStream()
        let chatPostId = uuidv4()
        let tabName = tabNameChatAI;

        const isRunCommandSdauto = value.startsWith(Constant.SD_AUTO_COMMAND);
        const isRunCommandTranslate = value.startsWith(Constant.TRANS_FILE_COMMAND);
        const isRunCommand = isRunCommandSdauto || isRunCommandTranslate;

        if (!isRunCommand) {
            setTimeout(async() => {
                setIsShowButtonStop(true);
            }, 200)
            setIsOnlyRunChatAI(true);
            setIsStopStreamContent('');
        }
        // Only SUCCESS items are sent. Images: normal chat only (not sdauto, not transfile).
        // Documents: normal chat and transfile, NOT sdauto.
        const sendImgs = isRunCommand ? [] : successUploadImgs;
        const sendFiles = isRunCommandSdauto ? [] : successUploadFiles;
        const toFileAttachment = file => ({
            s3Path: file.s3Path,
            fileName: file.fileName,
            fileExtension: file.fileExtension,
            fileSize: file.fileSize
        });

        const attachments = sendImgs.map(img => ({
            localUrl: img.localUrl,
            s3Path: img.s3Path,
            thumbnailInfo: img.thumbnailInfo
        }));
        const fileAttachments = sendFiles.map(toFileAttachment);

        const mock = [
            {
                isFromMe: true,
                user: Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail),
                dateTime: formatUserDateTime(new Date().toISOString(), 'YYYY/MM/DD HH:mm', userDetail?.userSetting),
                content: value,
                attachments,
                fileAttachments,
                postType: !Utils.isEmptyArray(attachments)
                    ? Constant.POST_TYPE.IMAGE 
                    : !Utils.isEmptyArray(fileAttachments) 
                        ? Constant.POST_TYPE.FILE 
                        : Constant.POST_TYPE.MSG,
                isMockMsg: true,
            },
            //HIDDEN MESSAGE WARNING WHEN EXCEED MAX TOKEN
            {
                isFromMe: false,
                content: trI18n('WARNING_EXCEED_MAX_TOKEN'),
                isWaring: true,
                dateTime: formatUserDateTime(new Date().toISOString(), 'YYYY/MM/DD HH:mm', userDetail?.userSetting),
                isHidden: true
            },
            {
                isFromMe: false,
                isLoadingMessage: true,
                idOfLoadingMessage: uuidv4()
            }
        ];
        if (listMessageContent?.length === 0) {
            tabName = value;
            if (Utils.isEmptyString(tabName) && !Utils.isEmptyArray(successUploadImgs)) {
                tabName = successUploadImgs[0]?.fileData?.name || '';
            }
            if (Utils.isEmptyString(tabName) && !Utils.isEmptyArray(successUploadFiles)) {
                tabName = successUploadFiles[0]?.fileName || '';
            }
            updateTabNameAfterSendMessage(tabName, panelId, setPanelList, tabId);
        }

        setListMessageContent(prev => [...prev, ...mock]);
        setIsEnableBtnSend(false);
        setTextInput('');
        // Keep ERROR items so the user can see and remove them
        const isErrorItem = item => item.uploadStatus === Constant.AI_CHAT_UPLOAD_STATUS.ERROR;
        setUploadImgs(prev => prev.filter(isErrorItem));
        setUploadFiles(prev => prev.filter(isErrorItem));

        let drillDown = buildDrillDownSearchParam(filterKnowledgeListData?.viewStructure);
        let optionSearch = getOptionsSearch();

        let corporationId = corporationDetail.id;
        if (!Utils.isEmptyObject(projectInfo)) {
            corporationId = projectInfo?.affiliationOrganization;
        }
        const drillDownDataForLog = await getDrilldownItemDataSelected(API, filterKnowledgeListData?.viewStructure)
        const dataLog = {
            corporationDetail: corporationDetail,
            projectDetail: projectInuseDetail,
            userDetail: userDetail,
            rootProjectDetail: projectInfo,
            rootCorporationDetailId: corporationSelected,
            tabNameChatAI: `${tabName} ${tabId}`,
            aiChatInquiryText: value,
            basicPromptID: toggleUsingBasicPrompt ? basicPrompt : null,
            basicPromptName: toggleUsingBasicPrompt ? titleTicket : null,
            userSelectedPrompt: userSelectedPrompt,
            projectIdKnowledgeSelected: filterKnowledgeListData?.projectIdKnowledgeSelected,
            keyword: filterKnowledgeListData?.viewStructure?.keyword,
            viewName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, filterKnowledgeListData?.viewSelected?.name),
            searchTagSuggestKnowledge: Utils.createTagForLogKibana(drillDownDataForLog),
            isTurnOnToggleUsingKnowledgeTicketList: toggleUsingKnowledgeTicketList
        }

        const logKibanaData = createKibanaInteractChatAI(dataLog);
        let listUrlShareLink = Utils.getShareLinkUrls(value)

        // Split the 分析機能 sentinel out of selectedMcpServers → real MCP list + useKibanaMcp flag.
        // Sentinel lives in the array only on the frontend (for chip order + persist); never sent as an MCP id.
        // Gate by precondition so useKibanaMcp stays in sync with the chip (both hide realtime when org/project toggle off).
        const useKibanaMcp =
            (selectedMcpServers || []).includes(Constant.KIBANA_MCP_ID) &&
            isShowKibanaAnalysisOption({ corporationDetail, projectInuseDetail });
        const realSelectedMcpServers = (selectedMcpServers || []).filter(id => id !== Constant.KIBANA_MCP_ID);

        const dto = {
            corporationId: corporationId,
            projectId: filterKnowledgeListData?.projectIdKnowledgeSelected,
            currentUserId: userDetail.id,
            chatThreadId: chatThreadId,
            message: value,
            basePrompt: basicPrompt ? basicPrompt : '',
            usingBasicPrompt: !!usingBasicPrompt,

            visibilitySettingType: filterKnowledgeListData?.viewStructure?.visibility
                ? filterKnowledgeListData?.viewStructure?.visibility : Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
            visibilitySetting: 'new_arrived_knowledge',
            publicRange: '',
            projectInuse: projectInuseDetail.id,
            userAffiliationOrganization: userDetail.affiliationOrganization,
            projectInuseType: projectInuseDetail.type,
            viewId: filterKnowledgeListData?.viewSelectedId,
            optionSearch: optionSearch,
            drillDownSearch: drillDown,
            ticketIdList: [],
            ticketProperty: filterKnowledgeListData?.viewStructure?.ticketProperty,
            resetSearchCondition: !!resetSearchCondition,
            from: 0,
            size: 30,
            logKibanaData: JSON.stringify(logKibanaData),
            chatPostId: chatPostId,
            listUrlShareLink: listUrlShareLink,
            currentCorporationId: corporationDetail.id,
            ticketCreatedProjectId: filterKnowledgeListData.ticketCreatedProjectId,
            ticketCreatedCorporationId: filterKnowledgeListData.ticketCreatedCorporationId,
            chatGptModel: usingChatGptModel,
            attachments: JSON.stringify(sendImgs.map(img => ({
                s3Path: img.s3Path,
                fileInfo: Utils.normalizeFileData(img?.fileData),
                thumbnailInfo: img.thumbnailInfo
            }))),
            fileAttachments: JSON.stringify(sendFiles.map(toFileAttachment)),
            selectedMcpServers: realSelectedMcpServers,
            useKibanaMcp: useKibanaMcp,
            reasoningEffort: usingReasoningEffort
        };
        
        setUserSelectedPrompt([]);
        setIdOfResponseMessage(chatPostId)
        onUpdateTabChatConfigurations(
            setPanelList,
            panelId,
            tabId,
            usingChatGptModel,
            setUsingChatGptModel,
            selectedMcpServers,
            usingReasoningEffort,
            setUsingReasoningEffort
        );

        sendAIChatMessage(API, dto, setListMessageContent, setIsDisabledInputChat)

        if (isRunCommandSdauto || isRunCommandTranslate) {
            const removeS3PathList = [];
            if (isRunCommandSdauto) {
                removeS3PathList.push(
                    ...successUploadImgs.map(img => img.s3Path),
                    ...successUploadFiles.map(file => file.s3Path)
                );
            } else if (isRunCommandTranslate) {
                removeS3PathList.push(
                    ...successUploadImgs.map(img => img.s3Path),
                );
            }
            updatePublicAPI(null, {
                updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.REMOVE_UPLOAD_S3_FILE_LIST,
                s3PathList: [...removeS3PathList].filter(Boolean)
            });
        }
        return;
    };

    const onStopMessage = async value => {
        setIsShowButtonStop(false);
        setIsStopStreamContent(Constant.STREAM_STATUS.STOP);
        setIsEnableBtnSend(true);
        let reasoningData = [];
         if(!Utils.isEmptyArray(reasoningDataStream)){
            reasoningData = reasoningDataStream?.filter(item => !item.isDone)?.map(item =>  `${item.title}\n${item.text}`);
        }
         if (Utils.isEmptyString(streamedContent) && Utils.isEmptyArray(reasoningDataStream)) {
            setListMessageContent(prevList =>
                prevList.filter(
                    item => !(item.isLoadingMessage)
                )
            );
        }else{
            let findIndex = listMessageContent?.findIndex(item => item.isLoadingMessage)
            let message = listMessageContent[findIndex];
            let listMessageClone = [...listMessageContent];
            let newMessage = {
                isFromMe: false,
                content: streamedContent,
                dateTime: formatUserDateTime(new Date().toISOString(), 'YYYY/MM/DD HH:mm', userDetail?.userSetting),
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE,
                postType: 'msg',
                id: message.idOfLoadingMessage,
                reasoningData: reasoningDataStream
            };
            listMessageClone[findIndex] = newMessage;
            setListMessageContent([...listMessageClone])
        }

       
        // call update stop
        let param = {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.CREATE_OR_UPDATE_AI_CHATPOST,
            data: {
                id: idOfResponseMessage,
                corporationId: corporationDetail.id,
                affiliationProject: projectInuseDetail.id,
                postType: Constant.POST_TYPE.MSG,
                chatThreadId: chatThreadId,
                role: 'assistant',
                content: streamedContent,
                creatorId: 'chatGPT',
                streamStatus: Constant.STREAM_STATUS.STOP,
                reasoning: reasoningData
            }
        };
        
        await updatePublicAPI(API, param);
    }

    const onDrop = useCallback((acceptedFiles) => {
        if (!isCanAttachFile || Utils.isEmptyArray(acceptedFiles)) return;
        acceptAttachments(acceptedFiles, getAttachmentContext());
    }, [isCanAttachFile, uploadImgs, uploadFiles, chatThreadId, corporationDetail, projectInuseDetail]);

    const { getRootProps } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true
    });

    const handleRemoveUploadedImage = (removeImg) => {
        removeUploadedImage(removeImg, setUploadImgs);
    };

    const handleRemoveUploadedFile = (removeFile) => {
        removeUploadedFile(removeFile, setUploadFiles);
    };

    const isCanSendChat = () => {
        if (!isEnableBtnSend) return false;
        if (hasUploadingItem) return false;
        if (!Utils.isEmptyArray(successUploadImgs)) return true;
        if (!Utils.isEmptyArray(successUploadFiles)) return true;
        const inputText = textInput?.trim()
        return !Utils.isEmptyString(inputText)
    }
    
    return (
        <div className="chat-input-wrapper" {...getRootProps()}>
            {basicPrompt && (
                <div className="basic-prompt-chip">
                    <OverFlowTooltipWithTabsMui
                        value={trI18n('LABEL-BASIC-PROMPT')}
                        className={`name-title-tickets`}
                        onClick={()=> openPromptTicketPanel(
                            setIsLoading,
                            userDetail,
                            basicPrompt,
                            projectInuseDetail,
                            setIsOpenModalReloadPage,
                            addNewPanel,
                            setIsOpenAccessDeniedPopup,
                            corporationDetail,
                            setActionError
                        )}
                    />
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-basicPrompt-mode`}
                            checked={toggleUsingBasicPrompt}
                            value={toggleUsingBasicPrompt}
                            onChange={() => 
                                handleToggleUsingBasicPrompt(
                                    panelList,
                                    setPanelList,
                                    panelId,
                                    tabId,
                                    toggleUsingBasicPrompt,
                                    setToggleUsingBasicPrompt
                            )}
                        />
                        <label htmlFor={`switch-basicPrompt-mode`}></label>
                    </div>
                </div>
            )}

            {/* Preview Upload Files Container - Images and Files combined */}
            <AiPreviewUploadFiles
                uploadImgs={uploadImgs}
                uploadFiles={uploadFiles}
                onRemoveImage={handleRemoveUploadedImage}
                onRemoveFile={handleRemoveUploadedFile}
                onPreviewImage={(img) => {
                    setOpenPreviewImage({
                        isOpen: true,
                        imgUrl: img.localUrl
                    });
                }}
            />

            {/* Form AiChat Input Container */}
            <div className="groupForm-chat groupForm-ai-chat">
                <InputChatAiGroupButtons
                    API={API}
                    chatThreadId={chatThreadId}
                    // Model (used to check multimodal support)
                    usingChatGptModel={usingChatGptModel}
                    usingReasoningEffort={usingReasoningEffort}
                    
                    // UploadFile
                    onTriggerUploadFile={() => uploadFileRef.current?.triggerClick()}
                    isFileTranslationEnabled={isFileTranslationEnabled}

                    // ImageCapture
                    onTriggerImageCapture={() => imageCaptureRef.current?.triggerClick()}

                    // ReferenceKnowledge
                    isUsingKnowledgeService={isUsingKnowledgeService}
                    toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                    panelId={props.panelId}
                    tabId={props.tabId}
                    panelList={panelList}
                    setPanelList={setPanelList}

                    // MCPServerDropdownsUploading}
                    enqueueSnackbar={enqueueSnackbar}

                    // MCPServerDropdown
                    selectedCorporationDetail={corporationDetail}
                    serverList={mcpServerOptions}
                    selectedMcpServers={selectedMcpServers}
                    onMcpSelectionChange={setSelectedMcpServers}

                    // AiLogDetail
                    listMessageContent={listMessageContent}
                    isAiAssistantLog={isAiAssistantLog}

                    // KBoard sendAIChat setters
                    setListMessageContent={setListMessageContent}
                    setIsEnableBtnSend={setIsEnableBtnSend}
                    setIsShowButtonStop={setIsShowButtonStop}
                    setIsOnlyRunChatAI={setIsOnlyRunChatAI}
                    setIsStopStreamContent={setIsStopStreamContent}
                    setIdOfResponseMessage={setIdOfResponseMessage}
                    setIsDisabledInputChat={setIsDisabledInputChat}
                    setUsingChatGptModel={setUsingChatGptModel}
                    setUsingReasoningEffort={setUsingReasoningEffort}

                    // KBoard knowledge search context
                    filterKnowledgeListData={filterKnowledgeListData}
                />

                <div className="group-fild">
                    <div className="formField chat-form-input-field" data-cy="chat-form-input-field">
                        <TextField
                            multiline
                            name="chatbotName"
                            maxRows={12}
                            className={`form-control no-more-padding ai-send-input`}
                            variant="outlined"
                            autoComplete="off"
                            placeholder={tr('あなたのメッセージ...')}
                            onChange={onChangeChatInput}
                            onPaste={onPasteChatInput}
                            value={textInput}
                            onKeyDown={async e => await onEnterTextInput(e)}
                            disabled={isDisabledInputChat}
                            spellCheck={false}
                            inputRef={inputRef}
                        />
                        <PromptButton
                            isLoading={isLoading}
                            filterKnowledgeListData={filterKnowledgeListData}
                            promptOpen={promptOpen}
                            setPromptOpen={setPromptOpen}
                        />
                    </div>

                    <div className="ai-chat-group-btns">
                        {/* Image capture */}
                        {canUploadImgToSendAi && isDisplayImageCapture && (
                            <ImageCapture
                                showButton={false}
                                ref={imageCaptureRef}
                                corporationDetail={corporationDetail}
                                projectInuseDetail={projectInuseDetail}
                                chatThreadId={chatThreadId}
                                currentUploadImgs={uploadImgs}
                                currentUploadFiles={uploadFiles}
                                setUploadImgs={setUploadImgs}
                            />
                        )}

                        <UploadFile
                            showButton={false}
                            ref={uploadFileRef}
                            corporationDetail={corporationDetail}
                            projectInuseDetail={projectInuseDetail}
                            chatThreadId={chatThreadId}
                            uploadImgs={uploadImgs}
                            uploadFiles={uploadFiles}
                            setUploadImgs={setUploadImgs}
                            setUploadFiles={setUploadFiles}
                        />
                    </div>

                    <div className="selected-mcp-server-list">
                        <SelectedMcpServerChips
                            mcpServerOptions={mcpServerOptions}
                            selectedMcpServers={selectedMcpServers}
                            setSelectedMcpServers={setSelectedMcpServers}
                            projectInuseDetail={projectInuseDetail}
                        />
                    </div>

                </div>

                {/* SendAiChat Btn */}
                <button
                    className="btn-reset-default ai-chat-send-msg-btn"
                    disabled={!isShowButtonStop && !isCanSendChat()}
                    onClick={isShowButtonStop
                        ? async () => await onStopMessage(textInput)
                        : async () => await onSendMessage(textInput)
                    }
                >
                    {isShowButtonStop
                        ? <StreamStopIcon width={23} height={23} />
                        : <SendIcon width={18} height={18} />
                    }
                </button>
            </div>

            {/* Modals / Dialogs */}
            {promptOpen && (
                <AIPromptModal
                    isOpen={promptOpen}
                    setIsOpen={setPromptOpen}
                    corporationDetail={corporationDetail}
                    projectInuseDetail={projectInfo}
                    API={API}
                    setTriggerReload={setTriggerReload}
                    setTextInput={setTextInput}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    corporationSelected={corporationSelected}
                    promptInternalTicket={promptInternalTicket}
                    promptExternalTicket={promptExternalTicket}
                    setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                    setPromptOpen={setPromptOpen}
                    setUsingChatGptModel={setUsingChatGptModel}
                    setUsingReasoningEffort={setUsingReasoningEffort}
                    setSelectedMcpServers={setSelectedMcpServers}
                    selectedMcpServers={selectedMcpServers}
                    mcpServerOptions={mcpServerOptions}
                />
            )}
            
            <Dialog
                maxWidth="md"
                open={openPreviewImage.isOpen}
                onClose={() => setOpenPreviewImage({isOpen: false, imgUrl: ''})}
            >
                {openPreviewImage.imgUrl && (
                    <img
                        alt="preview-full"
                        src={openPreviewImage.imgUrl}
                        style={{
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                        }}
                    />
                )}
            </Dialog>

            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog 
                isOpen={!Utils.isEmptyString(actionError)} 
                okCallBack={() => {setActionError('')}} 
                msgConfirm={actionError}
                textSubmit={trI18n('OK')}
            />
        </div>
    );
}

InputChatAI.propTypes = {
    setListMessageContent: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    API: PropTypes.any,
    projectInfo: PropTypes.any,
    setTriggerReload: PropTypes.any,
    filterKnowledgeListData: PropTypes.any,
    basicPrompt: PropTypes.any,
    isEnableBtnSend: PropTypes.any,
    setIsEnableBtnSend: PropTypes.any,
    listMessageContent: PropTypes.any,
    resetSearchCondition: PropTypes.any,
    corporationSelected: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    titleTicket: PropTypes.any,
    setUserSelectedPrompt: PropTypes.any,
    userSelectedPrompt: PropTypes.any,
    promptInternalTicket: PropTypes.any,
    promptExternalTicket: PropTypes.any,
    setIsOpenModalReloadPage: PropTypes.any,
    isLoading: PropTypes.any,
    setIsLoading: PropTypes.any,
    usingBasicPrompt: PropTypes.any,
    setIdOfResponseMessage: PropTypes.any,
	usingChatGptModel: PropTypes.any,
	setUsingChatGptModel: PropTypes.any,
	toggleUsingKnowledgeTicketList: PropTypes.any,
	selectedMcpServers: PropTypes.array,

    isShowButtonStop: PropTypes.any,
    setIsShowButtonStop: PropTypes.any,
    isOnlyRunChatAI: PropTypes.any,
    setIsOnlyRunChatAI: PropTypes.any,

    setStreamedContent: PropTypes.any,
    streamedContent: PropTypes.any,

    isStopStreamContent: PropTypes.any,
    setIsStopStreamContent: PropTypes.any,

    idOfResponseMessage: PropTypes.any,
    reOpenKnowledgePanel: PropTypes.func,
    isInvalidPrecondition: PropTypes.bool,
    initHitNumber: PropTypes.number,
    chatGPTModelListOptions: PropTypes.array,
};

export default InputChatAI;
